import { Activity, BarChart3, Hand, Sparkles, Waves } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { HowItWorksStep } from '@marketing/data/howItWorks';

const MAP: Record<HowItWorksStep['iconKey'], LucideIcon> = {
  hands: Hand,
  wearable: Activity,
  spark: Sparkles,
  chart: BarChart3,
  waves: Waves,
};

export function StepIcon({
  iconKey,
  size = 24,
}: {
  iconKey: HowItWorksStep['iconKey'];
  size?: number;
}) {
  const Icon = MAP[iconKey];
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size + 18,
        height: size + 18,
        borderRadius: 12,
        background: 'var(--color-brand-100)',
        color: 'var(--color-brand-900)',
      }}
    >
      <Icon size={size} strokeWidth={1.75} aria-hidden="true" />
    </span>
  );
}
